import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

export default function useLegalDateFormat(isoDate) {
  dayjs.extend(utc);
  const d = dayjs.utc(isoDate).format('MMMM D, YYYY');
  return d;
}
